/**
 * The FaqCategoryList view
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";
import { Card, CardImg, CardTitle, CardBody } from "reactstrap";

import icon_order from "../../assets/images/icons/perks/box-checklist.svg";
import icon_payment from "../../assets/images/icons/perks/creditcard.svg";
import icon_assembly from "../../assets/images/icons/perks/tools.svg";
import icon_shipping from "../../assets/images/icons/perks/fast-delivery.svg";
import icon_production from "../../assets/images/icons/perks/factory.svg";
import icon_design from "../../assets/images/icons/perks/paint-palette-and-brush.svg";
import icon_voucher from "../../assets/images/icons/perks/voucher.svg";
import icon_info from "../../assets/images/icons/perks/info.svg";
import icon_fileguide_bleed from "../../assets/images/icons/bleed.svg";
import icon_fileguide_colors from "../../assets/images/icons/colour.svg";
import icon_fileguide_dpi from "../../assets/images/icons/images.svg";
import icon_fileguide_upload from "../../assets/images/icons/fileupload.svg";
import icon_fileguide_fonts from "../../assets/images/icons/font-size.svg";
import icon_fileguide_filetypes from "../../assets/images/icons/pdf.svg";

/**
 * The `show` container for an FaqCategory.
 * Both the component and the connected component are exported for testing purpose
 */
export class FaqCategoriesListView extends Component {
  /**
   * renders the faqcategory data
   */
  render() {
    const { faqcategories, handleShowFaqCategory } = this.props;
    const icons = {
      "deine-bestellung": icon_order,
      zahlung: icon_payment,
      "montage-demontage": icon_assembly,
      produktion: icon_production,
      druckdaten: icon_design,
      "versand-lieferung": icon_shipping,
      "gutscheine-aktionen": icon_voucher,
      produktinformationen: icon_info,
      "fileguide-format": icon_fileguide_bleed,
      "fileguide-colors": icon_fileguide_colors,
      "fileguide-dpi": icon_fileguide_dpi,
      "fileguide-fileupload": icon_fileguide_upload,
      "fileguide-fonts-and-lines": icon_fileguide_fonts,
      "fileguide-filetypes": icon_fileguide_filetypes,
    };
    return (
      <Container>
        <Row className="faqcategories-list">
          {faqcategories &&
            faqcategories.map &&
            faqcategories.map((faqcategory) => (
              <Col
                md={4}
                className="my-1"
                key={"faqcategory_" + faqcategory.id}
                onClick={handleShowFaqCategory.bind(this, faqcategory.slug)}
              >
                <Card>
                  <CardImg
                    top
                    src={icons[faqcategory.slug] || icon_info}
                    alt={faqcategory.title}
                  />
                  <CardBody>
                    {faqcategory.title && (
                      <CardTitle>{faqcategory.title}</CardTitle>
                    )}
                  </CardBody>
                </Card>
              </Col>
            ))}
        </Row>
      </Container>
    );
  }
}

/**  define proptype for the 'translation' function  */
FaqCategoriesListView.contextTypes = {
  t: PropTypes.func,
};

/** export the redux connected component and add a frontload call */
export default FaqCategoriesListView;
